import { useQuery } from "react-query";
import api from "../api";

export const useGetKycByEmail = (email) => {
  return useQuery(["kyc-by-email"], () => {
    return api.get(`/user/${email}/kyc`).then((res) => res.data);
  });
};
